(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-card-collection"] && !Shopify.designMode) return;
  try {
    
  // Guard against browser scroll-anchoring auto-advancing the carousel on
  // load, same fix already proven on the System card block's own carousel.
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.pdp-card-collection__track').forEach(function (track) {
      if (track.dataset.pdpScrollGuard) return;
      track.dataset.pdpScrollGuard = 'true';
      var userInteracted = false;
      ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (evt) {
        track.addEventListener(evt, function () { userInteracted = true; }, { passive: true });
      });
      var guardUntil = Date.now() + 1500;
      var reset = function () {
        if (!userInteracted) track.scrollLeft = 0;
      };
      track.addEventListener('scroll', function () {
        if (!userInteracted && Date.now() < guardUntil) track.scrollLeft = 0;
      }, { passive: true });
      [0, 50, 150, 300, 600, 1000, 1500].forEach(function (delay) {
        setTimeout(reset, delay);
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
